







































import { getCompanyMeasure } from '@/services/api';
import { isEnableAuth } from '@/utils/experiment';
import { getCompanyInfo } from '@/utils/getCompanyInfo';
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

@Component({})
export default class ABTestDisplayTableItemDialog extends Vue {

  @Prop()
  visible!:boolean;

  @Watch('visible')
  resetLastMeasure() {
    if (this.visible) {
      this.lastSelectedColumn = JSON.parse(JSON.stringify(this.selectedColumn))
    } else {
      this.selectedColumn = JSON.parse(JSON.stringify(this.lastSelectedColumn))
    }
  }

  get enableAuth() {
    return isEnableAuth();
  }

  public columnsMap:any = {
    'viewCnt': '曝光用户数',
    'signupCnt': '提交用户数',
    'signupRate': '提交转化率',
    'orderRate': '下单转化率',

    'phoneCnt': '收集手机号总量',
    'viewRate': '曝光率',
    'orderCnt': '下单数',

    ...(this.enableAuth ? {
      'loginEmailCnt': '第三方登录收集邮箱总量',
      'loginSignUpCnt': '第三方登录提交用户数'
    } : {}),
  }

  public selectedColumn:string[] = []
  public lastSelectedColumn = []

  public tableColumnsList: string[] = []
  public selectColumnsList = this.enableAuth
    ? ['viewCnt', 'loginEmailCnt', 'signupCnt', 'loginSignUpCnt', 'signupRate', 'orderRate']
    : ['viewCnt', 'signupCnt', 'signupRate', 'orderRate'];

  mounted() {
    // TODO: 需后端修改
    // TODO: 获取当前abtest的measure
    getCompanyMeasure({
      measureCategory: "FORMABTEST"
    }, true).then((res:any) => {
      let measures = res.data.data.measures;
      if(measures?.length){
        this.selectedColumn = measures
        this.tableColumnsList = measures
      }else{
        this.selectedColumn = this.tableColumnsList = ['viewCnt', 'signupCnt', 'signupRate', 'orderRate'];
      }
    })
  }

  close() {
    this.selectedColumn = this.tableColumnsList
    this.$emit('update:visible', false);
  }

  sureDataShowVisible() {
    this.$emit('changeMeasure', this.selectedColumn);
    setTimeout(() => {
      getCompanyMeasure({
        measureCategory: "FORMABTEST"
      }, true).then((res:any) => {
        let measures = res.data.data.measures;
        if(measures?.length){
          this.selectedColumn = measures
          this.tableColumnsList = measures
        }else{
          this.selectedColumn = this.tableColumnsList = ['viewCnt', 'signupCnt', 'signupRate', 'orderRate'];
        }
      })
    }, 2000);
  }

}

